<template>
  <a-modal
    title="新建结算数量质量"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <div>
      <a-form :form="form" :layout="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="true">
            <a-form-item label="购销全流程" v-if="true" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                :not-found-content="sellContractFetching ? undefined : null"
                @change="handleSellContractChange"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="sellContractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedSellContract !== undefined && otherData.product_parameters.length > 0">
            <a-form-item :label="selectedSellContract.product_name" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-table
                bordered
                :data-source="otherData.product_parameters"
                :columns="parameterColumns"
                v-if="this.otherData.product_parameters.length > 0"
                :pagination="false"
                key="key">
                <span slot="serial" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
                <template slot="value" slot-scope="text, record">
                  <div>
                    <a-input-number style="width: 100%" :precision="4" :default-value="text" placeholder="实际值" @change="e => handleItemChange(e, record.id, 'value')"/>
                  </div>
                </template>
                <template slot="action" slot-scope="text, record" v-if="false">
                  <a-popconfirm
                    v-if="otherData.product_parameters.length"
                    title="确定删除?"
                    @confirm="() => onParameterDelete(record.id)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="contractType === 2">
            <a-form-item label="普通合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in contractList">{{ val.number }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              结算信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算数量依据" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-if="settlementQuantityBasisShow"
                v-decorator="[
                  'settlement_quantity_basis',
                  {
                    rules: [
                      { required: false, message: '请选择' },
                    ],
                  },
                ]"
                allow-clear
                placeholder="结算数量依据"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="val" v-for="(val, key) in selectedSellContract['settlement_volume_content']">{{ val }}</a-select-option>
              </a-select>
              <a-input
                v-else
                :rows="1"
                v-decorator="['settlement_quantity_basis', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]"
                placeholder="结算数量依据"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_quantity', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="结算数量"/>
              <a-select
                style="width: 45%; margin-left: 3px"
                v-decorator="[
                  'settlement_unit',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="单位"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否存在扣减项" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'has_deduction_item',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="hasDeductionItem"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.is_has_deduction_item">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="has_deduction_item === 1">
            <a-form-item label="扣减数量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['deduction_quantity', {rules: [{required: has_deduction_item === 1, message: '必填项，请填写信息'}]}]" placeholder="结算数量"/>
              <a-select
                style="width: 45%; margin-left: 3px"
                v-decorator="[
                  'unit',
                  {
                    rules: [
                      { required: has_deduction_item === 1, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="单位"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="最终结算数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['final_settlement_quantity', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="最终结算数量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算质量依据" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input allow-clear :rows="1" v-decorator="['settlement_quality_basis', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="结算数量依据"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算质量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_quality', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算质量"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否存在质量扣款" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'has_quality_deduction',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="hasQualityDeduction"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.is_has_deduction_item">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="has_quality_deduction === 1">
            <a-form-item label="扣款总金额" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['total_deduction_amount', {rules: [{required: has_quality_deduction === 1, message: '必填项，请填写信息'}]}]" placeholder="扣款总金额"/>
              <a-select
                style="width: 45%; margin-left: 3px"
                v-decorator="[
                  'currency',
                  {
                    rules: [
                      { required: has_quality_deduction === 1, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'settlement_pricing_currency',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="pricingCurrencyChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算单价"/>
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算汇率"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算金额"/>
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开启审批" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="obj"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="obj"/>
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { sell_contract_list, sell_contract_settlement_volume_list } from '@/api/trade_sell_contract'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { product_parameter_list } from '@/api/trade_product_parameter'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

// 表单字段
const fields = ['id', 'number']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      is_has_deduction_item: this.$Dictionaries.is_has,
      is_has_quality_deduction: this.$Dictionaries.is_has,
      contractList: [],
      sellContractList: [],
      projectList: [],
      contractType: 0,
      selectedProjectId: undefined,
      contractTypes: this.$Dictionaries.contractTypes,
      currentComponent: '',
      projectFetching: false,
      sellContractFetching: false,
      visibleFrom: false,
      confirmLoadingFrom: false,
      settlementQuantityBasisShow: false,
      has_deduction_item: 0,
      has_quality_deduction: 0,
      pricingCurrency: undefined,
      selectedSellContract: undefined,
      obj: {},
      otherData: {
        attachment: [],
        product_parameters: []
      },
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      parameterColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 100,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_value_compare_symbol[text] || '无'
        },
        {
          title: '合同值',
          dataIndex: 'standard_value',
          width: 150,
          ellipsis: true
        },
        {
          title: '实际值',
          dataIndex: 'value',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'value' }
        }
        // ,
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: 150,
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.model)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 8 },
          wrapperCol: { span: 16 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 20 }
        } : {}
    }
  },
  methods: {
    moment,
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.sellContractList = []
        this.form.setFieldsValue({
          contract_id: undefined
        })
        this.handleSellContractSearch()
      }
    },
    handleSellContractSearch () {
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.$route.params.project_id === undefined ? this.selectedProjectId : this.$route.params.project_id, page: 1, page_size: 999, is_expired: false }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            const current_date = new Date()
            values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            this.otherData.attachment.push(values)
          }
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      this.$emit('ok', this.otherData)
    },
    hasDeductionItem (value) {
      this.has_deduction_item = Number(value)
    },
    hasQualityDeduction (value) {
      this.has_quality_deduction = Number(value)
    },
    handleSellContractChange (sell_contract_id) {
      if (sell_contract_id > 0) {
        this.selectedSellContract = this.sellContractList.filter(item => item.id === sell_contract_id)[0]
        // 获取购销合同关联的产品参数
        product_parameter_list({ sell_contract_id: sell_contract_id }).then(res => {
          if (res.code === 1000) {
            console.log(res)
            if (res.data.entries !== undefined && res.data.entries.length > 0) {
              // const current_date = new Date()
              this.otherData.product_parameters = res.data.entries.map(item => {
                item['value'] = ''
                // item['key'] = item.id === undefined ? (current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + Math.floor(Math.random() * 100000)) : item.id
                return item
              })
            } else {
              this.otherData.product_parameters = []
            }
          }
        })
        console.log('handleSellContractChange', this.selectedSellContract)
        this.form.setFieldsValue({
          settlement_quality_basis: this.selectedSellContract.quality_deduction_reason
        })
        this.selectedSellContract['settlement_volume_content'] = undefined
          // 获取购销合同关联的结算量单位信息
        sell_contract_settlement_volume_list({ sell_contract_id: sell_contract_id }).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            const settlementVolume = res.data.entries[0]
            this.selectedSellContract['settlement_volume_content'] = settlementVolume.settlement_volume_content.split(',')
            console.log('==============', this.selectedSellContract['settlement_volume_content'])
            const result = this.selectedSellContract !== undefined
            const result2 = this.selectedSellContract['settlement_volume_content'] !== undefined
            const result3 = this.selectedSellContract['settlement_volume_content'].length > 0
            this.settlementQuantityBasisShow = this.selectedSellContract !== undefined && this.selectedSellContract['settlement_volume_content'] !== undefined && this.selectedSellContract['settlement_volume_content'].length > 0
            console.log('----------------', result, result2, result3, result && result2 && result3, this.settlementQuantityBasisShow)
            // this.form.setFieldsValue({
            //   settlement_quantity_basis: settlementVolume.settlement_volume_content
            // })
          }
        }).finally(() => {
          this.form.setFieldsValue({
            settlement_quantity_basis: undefined
          })
        })
      }
    },
    onParameterDelete (key) {
      this.otherData.product_parameters = this.otherData.product_parameters.filter(product => {
        return product.id !== key
      })
    },
    handleItemChange (value, key, column) {
      const newData = [...this.otherData.product_parameters]
      const target = newData.find(item => key === item.id)
      if (target) {
        target[column] = value
        this.otherData.product_parameters = newData
      }
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    }
  }
}
</script>
